import React from 'react';
import styled from 'styled-components';

const ErrorMessage = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.red['200']};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.red['600']};
  display: flex;
  gap: 8px;
  padding: 16px;
`;

type Props = {
    icon?: React.ReactNode;
    message: string;
};

const ErrorMessageComponent = ({ icon, message }: Props) => {
    if (!message) return null;

    return (
        <ErrorMessage role="alert">
            {icon && <span>{icon}</span>}
            <span>{message}</span>
        </ErrorMessage>
    );
};

export default ErrorMessageComponent;
